/**
 * basement-cms — wiring del `StorefrontFeatureService` al bootstrap.
 *
 * `provideAppInitializer` (D-8) garantiza que el mapa de features público quede
 * resuelto ANTES de que se cree el primer componente ruteado — el único
 * consumidor del token `FEATURED_OFFERS_ENABLED` es un field initializer de
 * componente, así que cuando su factory corre el snapshot ya está poblado y el
 * token sigue siendo `boolean` puro (call-site intacto).
 *
 * En SSR el server await-ea la Promise (HTML con el valor correcto); en browser
 * el mismo initializer lee el `TransferState` embebido (cero red). `load()`
 * jamás rechaza: un flag no puede tumbar el bootstrap.
 *
 * Se registra una vez en `app.config.ts`.
 */
import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { StorefrontFeatureService } from './storefront-feature.service';

/**
 * Provee la resolución runtime de los flags públicos del storefront: un
 * `provideAppInitializer` que carga el mapa de features antes del bootstrap.
 * @returns Providers de entorno con el app-initializer de features.
 */
export function provideStorefrontFeatures(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => inject(StorefrontFeatureService).load()),
  ]);
}
